import { usePermissions } from '@/hooks/usePermissions';
import { AccessLevel } from '@/types/permissions';

interface PermissionRequiredProps {
  pageKey: string;
  minLevel?: AccessLevel;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function PermissionRequired({ pageKey, minLevel = 'READ', children, fallback = null }: PermissionRequiredProps) {
  const { level } = usePermissions({ pageKey });
  const lv = { NONE: 0, VIEWOWN: 1, READ: 2, READWRITE: 3, ADMIN: 4 };
  if (lv[level] >= lv[minLevel]) {
    return <>{children}</>;
  }
  return <>{fallback}</>;
}
